import axios from 'axios';
import {backendHost} from '../../config';

export const getSettingsCodeCountry = (params) => {
    return axios.get(`${backendHost}/api/client/settings/code_country`, {params});
};